



















import Vue from 'vue';
import Component from 'vue-class-component';

type Enfant = {
	nom: String,
	ddn: String
}

const Props = Vue.extend({
	props: {
		enfant: {
			type: Object as () => Enfant,
			default: ''
		}
	}
});

@Component
export default class BlocEnfantTemplate extends Props {
}
